export const RouteConstants = {
  WILDCARD: '*',
  LOGIN: '/login',
  LOGIN_CALLBACK: '/login/callback',
  BASE: '/',
  HOME: '/home',
  REPORTS: '/reports',
  USERS: '/users',
  INVESTIGATIONS: '/investigations',
  INVSTFORM: '/investigation/:investigationId/form',
  REVIEW_COMMITTEE_MEETING: '/investigation/:investigationId/review-committee/:meetingId',
  INVESTIGATION_DOCUMENTS: '/investigation/:investigationId/documents',
  LIBRARIES: '/library',
  PROSPECT: '/prospect',
};
